import { cardVariants as cardVariants$1 } from './card.variants.esm.js';

var cardVariants = Object.keys(cardVariants$1);
/**
 * The purpose of this variable is to keep consistent styling for all card icon buttons
 * All card icon buttons should use `ghost-neutral` and sized `24x24`.
 */
var CARD_ICON_BTN_STND_PROPS = {
  iconButtonProps: {
    variant: 'ghost-neutral',
    size: 'icon-std'
  },
  iconProps: {
    size: '1.25em'
  }
};

export { CARD_ICON_BTN_STND_PROPS, cardVariants };
//# sourceMappingURL=types.esm.js.map
